/**
 * Monta el widget de bracketing de Reveni y lo vuelve a montar tras cada cambio del carrito.
 *
 * El bundle de Reveni no expone nada: se ejecuta una vez, lee el carrito del data-products
 * de #reveni-bracketing-widget y monta en el elemento que nombre containerId. No hay API
 * para refrescarlo, así que la única salida es volver a ejecutar el script sobre un
 * elemento limpio — attachShadow lanza sobre uno ya montado.
 *
 * Dos detalles que obligan a hacerlo desde JS y no desde Liquid:
 *
 *   1. Un <script> dentro de innerHTML no se vuelve a ejecutar, y tanto el drawer como la
 *      página de carrito reemplazan su contenido así. Un script en el marcado solo
 *      funcionaría en la primera carga, nunca en el flujo de añadir al carrito.
 *   2. updateCartUI actualiza la página O el drawer, nunca los dos. Confiar en que Liquid
 *      repinte el div canónico dejaría su data-products obsoleto la mitad de las veces,
 *      así que los datos los ponemos aquí desde el payload de CART_UPDATE.
 */
(function () {
  var HOST = '[data-reveni-bracketing]';
  var TAG = 'script[data-reveni-bracketing]';
  var CANONICAL = 'reveni-bracketing-widget';

  var latestItems = null;

  function mount() {
    document.querySelectorAll(TAG).forEach(function (script) {
      script.remove();
    });

    // Primera pasada: dejar todos los hosts limpios y con datos frescos ANTES de
    // inyectar ningún script, porque todas las instancias leen del canónico.
    var hosts = [];
    document.querySelectorAll(HOST).forEach(function (el) {
      if (!el.getAttribute('data-reveni-src')) return;

      if (el.shadowRoot) {
        var fresh = el.cloneNode(false);
        el.replaceWith(fresh);
        el = fresh;
      }

      if (el.id === CANONICAL && latestItems) {
        el.setAttribute('data-products', JSON.stringify(latestItems));
      }

      hosts.push(el);
    });

    hosts.forEach(function (el) {
      var script = document.createElement('script');
      script.src = el.getAttribute('data-reveni-src');
      script.setAttribute('data-reveni-bracketing', '');
      document.body.appendChild(script);
    });
  }

  // CART_UPDATE se publica después del render, pero el render puede ser asíncrono.
  function schedule() {
    window.requestAnimationFrame(mount);
  }

  function ready() {
    schedule();

    if (window.theme && theme.pubsub && theme.pubsub.events) {
      theme.pubsub.subscribe(theme.pubsub.events.CART_UPDATE, function (payload) {
        if (payload && payload.cart && payload.cart.items) {
          latestItems = payload.cart.items;
        }
        schedule();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
